/***
 *
 *   TICKET CARD STYLES
 *   Ported from ui-reference/src/components/tickets/ticket-card.tsx.
 *
 **********/

const Style = {
    card: 'w-full rounded-lg border bg-surface p-3 text-left shadow-sm transition-shadow hover:shadow-md',
    subject: 'mb-3 line-clamp-2 text-sm font-medium text-text-primary',
    due: 'mb-2 flex items-center gap-1.5 text-xs',
    dueOverdue: 'font-semibold text-error',
    dueIdle: 'text-text-muted',
    footer: 'flex items-center justify-between',
    meta: 'flex items-center gap-3',
    comments: 'flex items-center gap-1 text-xs text-text-muted',
};

export default Style;
